/*
 * Pestaña Detalle: tabla filtrable de los DO pendientes con TableBasic del codekit.
 */
import { useMemo, useState } from "react";
import { Box, Input, Label, Select, Stack, StackRow, TableBasic } from "codekit";

import Panelbox from "./Panelbox";
import { fmtCOP } from "./utils/carthelp";

//Columnas de la tabla de detalle (ids sin espacios: se usan como grid-area)
const columns = [
  { id: "DONROXXX", title: "DO", sorted: false, orderBy: null, center: false },
  { id: "CLIENTEX", title: "Cliente", sorted: false, orderBy: null, center: false },
  { id: "GERENCIA", title: "Gerencia", sorted: false, orderBy: null, center: true },
  { id: "DIRECTOR", title: "Director de Cuenta", sorted: false, orderBy: null, center: false },
  { id: "TIPOOPEX", title: "Tipo", sorted: false, orderBy: null, center: false },
  { id: "FECCREAX", title: "Fecha Creación", sorted: false, orderBy: null, center: true },
  { id: "FECLEVXX", title: "Fecha Levante", sorted: false, orderBy: null, center: true },
  { id: "DIASXXXX", title: "Días", sorted: false, orderBy: null, center: true },
  { id: "VALORXXX", title: "Valor", sorted: false, orderBy: null, center: false },
];

/**
 * Construye las opciones de un select a partir de los valores únicos de una clave
 * @param {Array} mData Datos de trabajo
 * @param {string} sKey Clave a listar
 * @param {string} sAll Texto de la opción "todos"
 * @returns {Array} Opciones [{ value, text }]
 */
const buildOptions = (mData, sKey, sAll) => {
  const mVals = [...new Set(mData.map((r) => r[sKey]))].filter(Boolean).sort();
  return [{ value: "", text: sAll }, ...mVals.map((v) => ({ value: v, text: v }))];
};

/**
 * Renderiza la pestaña Detalle
 * @param {Object} props Propiedades del componente
 * @param {Array} props.data Datos de trabajo filtrados
 */
const Tabdetal = ({ data }) => {
  const [sSearch, setSearch] = useState("");
  const [sGerencia, setGerencia] = useState("");
  const [sDirector, setDirector] = useState("");
  const [sTipo, setTipo] = useState("");

  const mRows = useMemo(() => {
    const sQuery = sSearch.toLowerCase();
    return data
      .filter(
        (r) =>
          (!sQuery || r.NOMBRE.toLowerCase().includes(sQuery)) &&
          (!sGerencia || r.GERENCIA === sGerencia) &&
          (!sDirector || r["DIRECTOR DE CUENTA"] === sDirector) &&
          (!sTipo || r["TIPO DE OPERACIÓN"] === sTipo),
      )
      .sort((a, b) => b.VALOR - a.VALOR)
      .slice(0, 500)
      .map((mRow, nIndex) => ({
        id: nIndex,
        DONROXXX: mRow.DO,
        CLIENTEX: mRow.NOMBRE,
        GERENCIA: mRow.GERENCIA,
        DIRECTOR: mRow["DIRECTOR DE CUENTA"],
        TIPOOPEX: mRow["TIPO DE OPERACIÓN"],
        FECCREAX: mRow._fechaCreacionStr,
        FECLEVXX: mRow._fechaLevanteStr,
        DIASXXXX: mRow._dias ?? "-",
        VALORXXX: fmtCOP(mRow.VALOR),
      }));
  }, [data, sSearch, sGerencia, sDirector, sTipo]);

  return (
    <Panelbox title="Detalle de DO Pendientes" hint="Filtra y explora cada registro individual (máx. 500 filas)">
      <Box mb={5}>
        <Stack gap={3} columnsVariant="form-4">
          <StackRow>
            <Label>Cliente</Label>
            <Input placeholder="Buscar cliente..." value={sSearch} disableUppercase onChange={(e) => setSearch(e.target.value)} />
          </StackRow>
          <StackRow>
            <Label>Gerencia</Label>
            <Select options={buildOptions(data, "GERENCIA", "Todas las gerencias")} value={sGerencia} onChangeValue={({ option }) => setGerencia(option.value)} />
          </StackRow>
          <StackRow>
            <Label>Director de Cuenta</Label>
            <Select options={buildOptions(data, "DIRECTOR DE CUENTA", "Todos los directores")} value={sDirector} onChangeValue={({ option }) => setDirector(option.value)} />
          </StackRow>
          <StackRow>
            <Label>Tipo de Operación</Label>
            <Select options={buildOptions(data, "TIPO DE OPERACIÓN", "Todos los tipos")} value={sTipo} onChangeValue={({ option }) => setTipo(option.value)} />
          </StackRow>
        </Stack>
      </Box>
      <TableBasic columns={columns} data={mRows} dataLength={mRows.length} hasMore={false} fetchData={() => {}} />
    </Panelbox>
  );
};

export default Tabdetal;
